import { render, staticRenderFns } from "./TeachersTeachingProgressStatistics.vue?vue&type=template&id=5b57f7b6&scoped=true&"
import script from "./TeachersTeachingProgressStatistics.vue?vue&type=script&lang=js&"
export * from "./TeachersTeachingProgressStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TeachersTeachingProgressStatistics.vue?vue&type=style&index=0&id=5b57f7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57f7b6",
  null
  
)

export default component.exports